import { useIsMobile } from 'core/theme_deprecated/hooks';
import { useConfig } from './useConfig';

type Params = {
  ratio?: 'portrait' | 'square';
};

export const mobileScanSize = 280;
export const desktopScanSize = 352;

export const useScanSize = ({ ratio = 'portrait' }: Params = {}) => {
  const { isMobile } = useIsMobile();
  const { palmPhotoLongSide, palmPhotoShortSide } = useConfig();

  if (ratio === 'square') {
    return {
      width: isMobile ? mobileScanSize : desktopScanSize,
      height: isMobile ? mobileScanSize : desktopScanSize,
    };
  }

  return {
    width: isMobile ? palmPhotoShortSide : palmPhotoLongSide,
    height: isMobile ? palmPhotoLongSide : palmPhotoShortSide,
  };
};
